<template>
    <div>
        <b-form-group label="Código VHE" label-for="vhe-code">
            <b-input-group>
                <b-form-input v-model="localInstallationCode" placeholder="VHE" autocomplete="off"
                              :class="validation ? 'is-invalid': ''"/>
                <b-input-group-append>
                    <b-button
                        class="btn-icon border-left-0 nav-arrow-btn"
                        :class="prevId ? 'nav-arrow-btn--active' : 'nav-arrow-btn--inactive'"
                        :disabled="!prevId"
                        @click="$emit('navigate', prevId)"
                    >
                        <feather-icon icon="ChevronLeftIcon" size="16"/>
                    </b-button>
                    <b-button
                        class="btn-icon border-left-0 nav-arrow-btn"
                        :class="nextId ? 'nav-arrow-btn--active' : 'nav-arrow-btn--inactive'"
                        :disabled="!nextId"
                        @click="$emit('navigate', nextId)"
                    >
                        <feather-icon icon="ChevronRightIcon" size="16"/>
                    </b-button>
                </b-input-group-append>
            </b-input-group>
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BButton} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormInput,
        BInputGroup,
        BInputGroupAppend,
        BButton,
    },
    props: {
        installationCode: {
            type: String,
            default: ''
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        prevId: {
            type: Number,
            default: null,
        },
        nextId: {
            type: Number,
            default: null,
        },
    },
    computed: {
        localInstallationCode: {
            get() {
                return this.installationCode
            },
            set(value) {
                this.$emit('update', {installation_code: value})
            },
        },
    },
}
</script>

<style scoped>
.nav-arrow-btn {
    border: none !important;
    opacity: 1 !important;
}

.nav-arrow-btn--active {
    background-color: #D3EDF6 !important;
    color: #0a58ca !important;
}

.nav-arrow-btn--active:hover {
    background-color: #D3EDF6 !important;
    color: #084298 !important;
}

.nav-arrow-btn--inactive {
    background-color: #e8f1ff !important;
    color: #a8c4f5 !important;
    cursor: not-allowed !important;
}
</style>
